import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";
import { Reveal, DynamicIcon, Button } from "../components/ui";
import { PageHero } from "./About";
import SEO from "../components/SEO";
import { optimg } from "../lib/img";
import { ArrowRight } from "lucide-react";

const CATEGORIES = ["Architecture", "Interior", "Construction", "Additional"];

export default function Services() {
  const [services, setServices] = useState([]);
  useEffect(() => { api.get("/services").then((r) => setServices(r.data || [])); }, []);

  return (
    <>
      <SEO title="Services" description="Architecture, Interior and Construction services by GNONS in Indore." />
      <PageHero kicker="Our Services" title="We Provide Best Services" subtitle="End-to-end architecture, interior and construction solutions." />

      <section className="py-16 md:py-20 bg-white">
        <div className="container-x space-y-16">
          {CATEGORIES.map((cat) => {
            const items = services.filter((s) => s.category === cat);
            if (!items.length) return null;
            return (
              <div key={cat}>
                <Reveal className="mb-8"><div className="kicker mb-2">{cat}</div><h2 className="text-2xl md:text-3xl font-bold text-ink">{cat} Services</h2></Reveal>
                <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
                  {items.map((s, i) => (
                    <Reveal key={s.id} delay={i * 60}>
                      <Link to={`/services/${s.slug}`} data-testid={`service-${s.slug}`} className="group block h-full rounded-xl2 border border-line bg-white overflow-hidden hover:shadow-lift hover:-translate-y-1 transition-all duration-400">
                        <div className="relative aspect-[16/10] overflow-hidden">
                          <img src={optimg(s.cover_image, { w: 640, h: 400 })} alt={s.name} loading="lazy" className="img-cover group-hover:scale-105 transition-transform duration-700" />
                          <div className="absolute inset-0 bg-gradient-to-t from-ink/50 to-transparent" />
                          <div className="absolute top-4 left-4 w-11 h-11 rounded-xl glass flex items-center justify-center"><DynamicIcon name={s.icon} className="text-gold" size={22} /></div>
                        </div>
                        <div className="p-6">
                          <h3 className="text-lg font-bold text-ink">{s.name}</h3>
                          <p className="mt-2 text-sm text-muted">{s.short_description}</p>
                          <span className="inline-flex items-center gap-1.5 mt-4 text-sm font-semibold text-gold">Learn More <ArrowRight size={15} className="group-hover:translate-x-1 transition-transform" /></span>
                        </div>
                      </Link>
                    </Reveal>
                  ))}
                </div>
              </div>
            );
          })}
        </div>
      </section>
    </>
  );
}
